<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div class="container-fluid">
    <div class="row h-100">
      <Sidebar></Sidebar>
      <div class="col-sm p-0">
        <div class="manageshipment">
          <div class="container-fluid h-100 p-0">
            <div
              class="manageshipment__mastercontent"
              style="height: calc(100vh - 110px) !important"
            >
              <div class="pt-2 manageshipment__wrapper2">
                <div class="d-flex justify-content-between mb-5 mt-3">
                  <router-link
                    :to="{
                      name: 'warehouseList',
                      params: { type: $route.params.type }
                    }"
                    class="d-flex justify-content-center align-items-center"
                    style="text-decoration: none;color: #1D3354;"
                  >
                    <img
                      class="mr-2"
                      src="@/assets/image/icon/cheveron-left.svg"
                    />
                    Back
                  </router-link>
                  <div v-if="$route.params.type === 'waiting-inbound'">
                    <button
                      class="redwhite"
                      @click="confrimModal($route.params.id)"
                    >
                      Cancel Inbound
                    </button>
                  </div>
                </div>
                <div
                  v-if="inboundStatus === 'CANCELLED'"
                  class="alert alert-danger text-center"
                  role="alert"
                >
                  {{
                    cancelBy === 'CUSTOMER'
                      ? 'You have canceled this inbound'
                      : 'This inbound has been cancelled by Andalin'
                  }}
                </div>
                <div
                  v-if="inboundStatus === 'REJECTED'"
                  class="alert alert-dark text-center"
                  role="alert"
                >
                  This inbound has been rejected by Andalin
                </div>
                <div class="text-center" v-if="isLoadingInboundDetail">
                  <b-spinner label="Loading..."></b-spinner>
                </div>
                <div v-else class="pdetail__border p-4 mb-5">
                  <div class="row m-0 mb-4">
                    <button
                      class="menutabs"
                      :class="selectedtabs === tab.router ? 'menuactive' : ''"
                      v-for="tab in tabs"
                      :key="tab.id"
                      @click="changeTab(tab.router)"
                    >
                      <p class="text-center">{{ tab.title }}</p>
                    </button>
                  </div>
                  <div v-if="selectedtabs === 'detail'">
                    <div
                      class="d-flex align-items-center justify-content-between pdetail__header mb-3 mt-2"
                    >
                      <p>Inbound Info</p>
                      <p>Inbound ID : {{ form.inboundId || '-' }}</p>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">Warehouse</p>
                        <div class="options__multipleselect">
                          <multiselect
                            v-model="form.warehouse"
                            :options="warehouseList || []"
                            placeholder="Select warehouse"
                            label="name"
                            :select-label="''"
                            :deselect-label="''"
                            disabled
                          >
                            <span slot="noResult"
                              >Oops! No elements found.</span
                            >
                          </multiselect>
                          <img
                            class="options__multipleselect--imgabsolute"
                            src="@/assets/image/icon/arrow-down-full-blue.svg"
                          />
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">Inbound Date</p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.dateInbound"
                              type="date"
                              name="Inbound Date"
                              :min="getDate(new Date())"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">
                          Total SKU
                        </p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              :value="listData.length"
                              type="text"
                              name="Total SKU"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">
                          Total Inbound Quantity
                        </p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              :value="
                                listData.reduce(
                                  (a, b) => a + (b['quantity'] || 0),
                                  0
                                )
                              "
                              type="text"
                              name="Total Inbound Quantity"
                              :disabled="true"
                            />
                          </b-input-group>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">
                          Reference Number (Optional)
                        </p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.referenceNumber"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">
                          Nomor Pengajuan (Optional)
                        </p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.nomorPengajuan"
                              disabled
                            />
                          </b-input-group>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="
                        inboundStatus === 'COMPLETED' ||
                          inboundStatus === 'INBOUND' ||
                          cancelBy !== 'CUSTOMER'
                      "
                      class="d-flex mb-2"
                    >
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">Master AWB</p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.mawb"
                              type="text"
                              name="Inbound awb"
                              disabled
                            />
                          </b-input-group>
                          <p class="paragraphmini">
                            This section will be soon updated by the operator
                          </p>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">House AWB</p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.hawb"
                              type="text"
                              name="Inbound hawb"
                              disabled
                            />
                          </b-input-group>
                          <p class="paragraphmini">
                            This section will be soon updated by the operator
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        inboundStatus === 'COMPLETED' ||
                          inboundStatus === 'INBOUND' ||
                          cancelBy !== 'CUSTOMER'
                      "
                      class="d-flex mb-2"
                    >
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">Master BL</p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.mbl"
                              type="text"
                              name="Inbound mbl"
                              disabled
                            />
                          </b-input-group>
                          <p class="paragraphmini">
                            This section will be soon updated by the operator
                          </p>
                        </div>
                      </div>
                      <div class="col-6">
                        <p class="fontstyle__default mb-1">House BL</p>
                        <div class="input__model1group">
                          <b-input-group>
                            <b-form-input
                              v-model="form.hbl"
                              type="text"
                              name="Inbound hbl"
                              disabled
                            />
                          </b-input-group>
                          <p class="paragraphmini">
                            This section will be soon updated by the operator
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- end list SKU -->
                  </div>

                  <div v-else-if="selectedtabs === 'sku-list'">
                    <section>
                      <div
                        class="d-flex justify-content-between align-items-center mb-3"
                      >
                        <p class="pdetail__header">SKU Information</p>
                        <div class="d-flex p-2">
                          <div class="d-flex align-items-center pr-2">
                            <span style="font-size: 14px">Filter By</span>
                          </div>
                          <div
                            class="options__multiselect d-flex align-items-center"
                          >
                            <multiselect
                              v-model="selected"
                              :options="filterOptions"
                              placeholder="Select"
                              selectedLabel=""
                              @input="filterChoice"
                              label="text"
                              :select-label="''"
                              :deselect-label="''"
                            >
                              <span slot="noResult"
                                >Oops! No elements found.</span
                              >
                            </multiselect>
                          </div>
                          <div class="input__model1group">
                            <b-input-group>
                              <b-form-input
                                v-if="selected.text != 'All'"
                                v-model="searchItem"
                                class="ml-3"
                                :placeholder="`Input ${selected.text}`"
                                style="height: 37px"
                                type="text"
                              />
                            </b-input-group>
                          </div>
                        </div>
                      </div>
                      <p class="text-sm mb-3" style="color: #7e7e7e">
                        Showing Total
                        <b class="text-1d3354">{{ listData.length }} SKU ID</b>
                      </p>
                      <!-- list SKU -->
                      <div
                        v-for="(item, index) in listData"
                        :key="item.id"
                        class="d-flex align-items-start"
                      >
                        <div class="text-base font-semibold text-1d3354 mr-3">
                          {{ index + 1 }}.
                        </div>
                        <div class="bg-card-list mb-3">
                          <div class="row">
                            <div class="col-md-2 pr-0 pb-3">
                              <div
                                class="d-flex flex-column align-center h-100 justify-content-center"
                              >
                                <img
                                  :src="item.img"
                                  :alt="`sku-image-${item.id}`"
                                  style="border-radius: 8px"
                                  class="w-100"
                                />
                              </div>
                            </div>
                            <div class="col-md-10 pl-0">
                              <div class="d-flex flex-column pl-4 mb-3">
                                <span class="font-bold text-1d3354">{{
                                  item.productInformation || '-'
                                }}</span>

                                <div class="d-flex gap-2">
                                  <div
                                    class="d-flex gap-2 align-items-center text-sm"
                                  >
                                    <div class="d-flex gap-2">
                                      <span class="text-muted"
                                        >Inbound Quantity</span
                                      >
                                      <span class="text-1d3354 font-semibold">{{
                                        item.quantity || '-'
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="row w-100">
                                <!-- col 1 -->
                                <div
                                  class="col-md-6 col text-1d3354 border-right border-e1e1e1"
                                >
                                  <div class="d-flex align-items-start">
                                    <div class="ml-4 w-100">
                                      <div
                                        class="d-flex p-0 align-items-start mb-2"
                                      >
                                        <p
                                          class="text-sm text-6e6e6e"
                                          style="width: 120px"
                                        >
                                          SKU ID
                                        </p>
                                        <p
                                          class="d-flex align-items-start text-sm"
                                        >
                                          <span class="mr-1">:</span>
                                          <span class="font-semibold">{{
                                            item.skuId || '-'
                                          }}</span>
                                        </p>
                                      </div>
                                      <div
                                        class="d-flex p-0 align-items-start mb-2"
                                      >
                                        <p
                                          class="text-sm text-6e6e6e"
                                          style="width: 120px"
                                        >
                                          HS Code
                                        </p>
                                        <p
                                          class="d-flex align-items-start text-sm"
                                        >
                                          <span class="mr-1">:</span>
                                          <span class="font-semibold">{{
                                            item.hsCode || '-'
                                          }}</span>
                                        </p>
                                      </div>
                                      <div
                                        class="d-flex p-0 align-items-start mb-2"
                                      >
                                        <p
                                          class="text-sm text-6e6e6e"
                                          style="width: 120px"
                                        >
                                          Gross Weight
                                        </p>
                                        <p
                                          class="d-flex align-items-start text-sm"
                                        >
                                          <span class="mr-1">:</span>
                                          <span class="font-semibold">{{
                                            item.weight
                                              ? parseFloat(
                                                  item.weight
                                                ).toLocaleString() + ' kg'
                                              : '-'
                                          }}</span>
                                        </p>
                                      </div>
                                      <div
                                        class="d-flex p-0 align-items-start mb-2"
                                      >
                                        <p
                                          class="text-sm text-6e6e6e"
                                          style="width: 120px"
                                        >
                                          Nett Weight
                                        </p>
                                        <p
                                          class="d-flex align-items-start text-sm"
                                        >
                                          <span class="mr-1">:</span>
                                          <span class="font-semibold">{{
                                            item.nettWeight
                                              ? parseFloat(
                                                  item.nettWeight
                                                ).toLocaleString() + ' kg'
                                              : '-'
                                          }}</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- col 2 -->
                                <div class="col-md-6 col text-1d3354 pl-4">
                                  <div
                                    class="d-flex p-0 align-items-start mb-2"
                                  >
                                    <p
                                      class="text-sm text-6e6e6e"
                                      style="width: 120px"
                                    >
                                      Country of Origin
                                    </p>
                                    <p class="d-flex align-items-start text-sm">
                                      <span class="mr-1">:</span>
                                      <span class="font-semibold">{{
                                        item.countryOrigin || '-'
                                      }}</span>
                                    </p>
                                  </div>
                                  <div
                                    class="d-flex p-0 align-items-start mb-2"
                                  >
                                    <p
                                      class="text-sm text-6e6e6e"
                                      style="width: 120px"
                                    >
                                      Item Number
                                    </p>
                                    <p class="d-flex align-items-start text-sm">
                                      <span class="mr-1">:</span>
                                      <span class="font-semibold">{{
                                        item.itemNumber || '-'
                                      }}</span>
                                    </p>
                                  </div>
                                  <div
                                    class="d-flex p-0 align-items-start mb-2"
                                  >
                                    <p
                                      class="text-sm text-6e6e6e"
                                      style="width: 120px"
                                    >
                                      CIF
                                    </p>
                                    <p class="d-flex align-items-start text-sm">
                                      <span class="mr-1">:</span>
                                      <span class="font-semibold">{{
                                        item.cif || '-'
                                      }}</span>
                                    </p>
                                  </div>
                                  <div
                                    class="d-flex p-0 align-items-start mb-2"
                                  >
                                    <p
                                      class="text-sm text-6e6e6e"
                                      style="width: 120px"
                                    >
                                      Packaging Type
                                    </p>
                                    <p class="d-flex align-items-start text-sm">
                                      <span class="mr-1">:</span>
                                      <span class="font-semibold">{{
                                        item.packagingType || '-'
                                      }}</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="w-100 d-flex pr-0 align-items-start mb-2 mt-2"
                          >
                            <p class="text-sm text-6e6e6e" style="width: 120px">
                              Notes
                            </p>
                            <p
                              class="text-sm text-1d3354 d-flex align-items-start"
                              style="width: calc(100% - 120px)"
                            >
                              <span class="mr-1">:</span>
                              <span
                                class="font-semibold"
                                v-html="item.notes || '-'"
                              />
                            </p>
                          </div>
                          <div
                            class="d-flex align-items-start mt-2 border-top mt-3 pt-3"
                            v-if="item.fileName && item.fileName.length > 0"
                          >
                            <p
                              class="pdetail__paragraph1 d-flex"
                              style="min-width: 156px"
                            >
                              <span>Uploaded Document</span
                              ><span class="px-2">:</span>
                            </p>
                            <div
                              class="d-flex align-items-center"
                              style="flex-wrap: wrap"
                            >
                              <div
                                class="pdetail__paragraph2"
                                v-for="(file, i) in item.fileName"
                                :key="i"
                              >
                                <p
                                  class="d-flex"
                                  @click="downloadSku(item, file)"
                                  style="
                                  text-decoration: underline !important;
                                  cursor: pointer;
                                "
                                >
                                  <span>{{ file ? file.name : '' }}</span>
                                  <span class="px-2">{{
                                    i != item.fileName.length - 1 ? ',' : ''
                                  }}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- end list SKU -->
                    </section>
                  </div>
                  <div v-else-if="selectedtabs === 'document'">
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr class="titleTable">
                            <th scope="col">Date and Time</th>
                            <th scope="col">File Name</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody
                          v-if="
                            inboundDetail &&
                              inboundDetail.documents &&
                              inboundDetail.documents.length > 0
                          "
                        >
                          <tr
                            v-for="data in inboundDetail.documents"
                            :key="data.id"
                            class="paragraphTable"
                          >
                            <td>{{ getDateTime(data.created_at) }}</td>
                            <td>{{ data.name }}</td>
                            <td>
                              <div class="d-flex items-center">
                                <button
                                  class="d-flex align-items-center justify-content-center button__whiteblueborder mr-2"
                                  style="min-width: 120px; font-size: 12px !important"
                                  @click="downloadFileInventory(data)"
                                >
                                  <div
                                    v-if="
                                      selectedDocument.id &&
                                        selectedDocument.id == data.id &&
                                        isLoadingDownloadFileInventory
                                    "
                                    class="spinner-border"
                                    role="status"
                                    style="
                                      width: 1rem !important;
                                      height: 1rem !important;
                                    "
                                  >
                                    <span class="sr-only">Loading...</span>
                                  </div>
                                  <span v-else>Download</span>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td style="font-size: 14px">
                              No Document Available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr class="titleTable">
                          <th scope="col">Date and Time</th>
                          <th scope="col">Update By</th>
                          <th scope="col">Activity</th>
                        </tr>
                      </thead>
                      <tbody v-if="inboundHistory && inboundHistory.length > 0">
                        <tr
                          v-for="data in inboundHistory"
                          :key="data.id"
                          class="paragraphTable"
                        >
                          <td>{{ getDateTime(data.created_at) }}</td>
                          <td>{{ data.c_user.fullname }}</td>
                          <td>{{ data.activity }}</td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td style="font-size: 14px;">
                            This inbound does not have any updated history
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modals">
      <b-modal
        ref="confirmInbound"
        id="modalConfirmInbound"
        centered
        hide-footer
        title="Confirmation"
      >
        <div class="__body text-center">
          <p class="mb-2">Are you sure that you cancel this Inbound?</p>
          <div class="d-flex justify-content-center mt-4">
            <button
              class="button__redcorporite mr-3"
              @click="$refs.confirmInbound.hide()"
            >
              No
            </button>
            <button class="button__bluecorporite" @click="cancelData">
              Yes
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modalPublishSuccess"
        ref="modalSuccessIQ"
        centered
        hide-footer
        title=""
      >
        <div>
          <div class="d-flex justify-content-center mb-2">
            <img
              style="width: 68px; height: 68px"
              src="@/assets/image/image/complete.png"
              alt=""
            />
          </div>
          <p class="text-center">
            Inbound has been canceled
          </p>
        </div>
        <div class="row mt-4">
          <div class="col-md text-center">
            <b-button
              @click="$refs.modalSuccessIQ.hide()"
              class="button__bluecorporite"
              >Ok
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
    <ModalSKU
      :viewModal="addModal"
      :editData="editData"
      @deleteData="editData = {}"
      @handle-edit-result="handleEditSkuResult($event)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import Sidebar from '@/components/global/Sidebar.vue'
import ModalSKU from '@/components/global/modals/modalAddSKU.vue'
export default {
  name: 'detail',
  components: {
    ModalSKU,
    Sidebar
  },
  data() {
    return {
      form: {
        inboundId: '',
        warehouse: '',
        dateInbound: '',
        dateOutbound: '',
        referenceNumber: '',
        nomorPengajuan: '',
        mawb: '',
        hawb: '',
        mbl: '',
        hbl: ''
      },
      id: '',
      selectedtabs: 'detail',
      type: '',
      inboundStatus: '',
      cancelBy: '',
      editData: {},
      addModal: false,
      listData: [],
      tabs: [
        {
          id: 1,
          title: 'Inbound Detail',
          router: 'detail'
        },
        {
          id: 2,
          title: 'SKU List',
          router: 'sku-list'
        },
        {
          id: 3,
          title: 'Document',
          router: 'document'
        },
        {
          id: 4,
          title: 'History',
          router: 'history'
        }
      ],
      selectedDocument: { id: null },
      filterOptions: [
        { text: 'All', value: '' },
        { text: 'SKU ID', value: 'skuId' },
        { text: 'Product Name', value: 'productInformation' },
        { text: 'Item Number', value: 'itemNumber' },
        { text: 'HS Code', value: 'hsCode' },
        { text: 'Notes', value: 'notes' }
      ],
      selected: {
        text: 'All',
        value: ''
      },
      searchItem: ''
    }
  },
  computed: {
    ...mapGetters({
      warehouseList: 'warehouse/warehouseList',
      isLoadingWarehouseList: 'warehouse/isLoadingWarehouseList',
      errorWarehouseList: 'warehouse/errorWarehouseList',

      inboundDetail: 'warehouse/inboundDetail',
      isLoadingInboundDetail: 'warehouse/isLoadingInboundDetail',
      errorInboundDetail: 'warehouse/errorInboundDetail',

      inboundHistory: 'warehouse/inboundHistory',
      isLoadingInboundHistory: 'warehouse/isLoadingInboundHistory',
      errorInboundHistory: 'warehouse/errorInboundHistory',

      isLoadingDownloadFileInventory: 'warehouse/isLoadingDownloadFileInventory'
    })
  },
  watch: {
    searchItem(value) {
      const lengthVar = value.length
      // eslint-disable-next-line consistent-return
      setTimeout(() => {
        if (lengthVar !== this.searchItem.length) {
          return false
        }
        this.fetchInboundDetail()
      }, 1000)
    }
  },
  async mounted() {
    await this.init()
  },
  methods: {
    async init() {
      await this.$store.dispatch('warehouse/FETCH_WAREHOUSE_LIST')
      await this.fetchInboundDetail()
      this.$store.dispatch('warehouse/INBOUND_HISTORY', this.$route.params.id)
    },
    async fetchInboundDetail() {
      const filter = this.selected.value
        ? `${this.selected.value}=${this.searchItem}`
        : ''
      await this.$store
        .dispatch('warehouse/FETCH_SKU_DETAIL', {
          id: this.$route.params.id,
          filter
        })
        .then(() => {
          if (this.inboundDetail) {
            this.initialValueInboundDetail(this.inboundDetail)
          }
        })
    },
    initialValueInboundDetail(data) {
      if (data) {
        this.listData = []
        if (this.warehouseList && this.warehouseList.length > 0) {
          const selectedWarehouse = this.warehouseList.find(
            el => el.id == data.warehouseId
          )
          if (selectedWarehouse) {
            this.form.warehouse = selectedWarehouse
          } else {
            this.form.warehouse = { id: data.id, name: data.warehouseName }
          }
        }
        this.inboundStatus = data.inboundStatus
        this.cancelBy = data.cancelledFrom
        this.form.inboundId = data.inboundId || '-'
        this.form.dateInbound = data.inboundDate
        this.form.dateOutbound = data.outboundDate
        this.form.referenceNumber = data.referenceNumber
        this.form.nomorPengajuan = data.nomorPengajuan
        this.form.mawb = data.masterAwb
        this.form.hawb = data.houseAwb
        this.form.mbl = data.masterBl
        this.form.hbl = data.houseBl

        data.sku.forEach(item => {
          let idSku = ''
          if (
            data.inboundStatus !== 'CANCELLED' ||
            (data.isCancelledFromDraft === 0 &&
              data.inboundStatus === 'CANCELLED')
          ) {
            idSku = item.skuId
          } else {
            idSku = '-'
          }
          this.listData.push({
            index: item.index,
            id: item.id,
            img:
              item.pictureUrl || require('@/assets/image/empty-sku-image.png'),
            skuId: idSku,
            productInformation: item.productInformation,
            companyName: data.companyName,
            hsCode: item.hsCode,
            itemNumber: item.itemNumber,
            packagingType: item.packagingType,
            quantity: Number(item.quantity),
            weight: Number(item.weight),
            nettWeight: Number(item.nettWeight),
            cif: item.cif,
            countryOrigin: item.countryOrigin,
            notes: item.notes,
            fileName: item.files,
            dataFoto: item.filePicture[0]
          })
        })
      }
    },
    cancelData() {
      this.$store.dispatch('warehouse/CANCEL_INBOUND', this.id).then(() => {
        if (!this.cancelInbound) {
          this.$refs.confirmInbound.hide()
          this.$refs.modalSuccessIQ.show()
          setTimeout(() => {
            this.$router.push('/warehouse-list/failed-inbound')
          }, 3000)
        }
      })
    },
    downloadSku(data1, data2) {
      const skuId = data1.id
      const fileId = data2.id
      const fileName = data2.original_name
      this.$store.dispatch('warehouse/DOWNLOAD_SKU', {
        skuId,
        fileId,
        fileName
      })
    },

    downloadFileInventory(data) {
      this.selectedDocument = data
      const fileId = data.id
      const fileName = data.original_name
      this.$store
        .dispatch('warehouse/DOWNLOAD_FILE_INVENTORY', {
          fileId,
          fileName,
          url: 'wms/inbound/download-file/'
        })
        .then(() => {
          if (this.errorDownloadFileInventory) {
            this.dataModalInfo.text = 'Failed'
            this.dataModalInfo.img = require('@/assets/image/icon/failed.svg')
            this.dataModalInfo.show = true
          }
        })
    },
    confrimModal(id) {
      this.id = id
      this.$refs.confirmInbound.show()
    },
    editModalSKU(data) {
      data.title = 'Edit'
      data.router = 'detail'
      this.addModal = true
      this.editData = data
      setTimeout(() => {
        this.addModal = false
      }, 2000)
    },
    changeTab(item) {
      this.selectedtabs = item
    },
    filterChoice() {
      if (this.selected.text === 'All') {
        this.searchItem = ''
      }
    },
    getDate(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    getDateTime(date) {
      return moment(date).format('DD/MM/YYYY hh:mm A')
    },
    async handleEditSkuResult(result) {
      if (result) {
        await this.fetchInboundDetail()
        await this.$store.dispatch(
          'warehouse/INBOUND_HISTORY',
          this.$route.params.id
        )
      }
    }
  }
}
</script>

<style lang="scss">
.bg-card-list {
  border-radius: 8px;
  width: 100%;
  border: 1px solid var(--neutral-100, #f5f6f7);
  background: var(--base-white, #fff);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06),
    0px 1px 3px 0px rgba(16, 24, 40, 0.1);
}
.pdetail {
  &__header {
    font-size: 16px;
    font-weight: 700;
    color: #1d3354;
    @media only screen and (max-width: 1536px) {
      margin: 1.5rem 0rem 0.5rem 0rem !important;
    }
  }
  &__paragraph1 {
    font-size: 14px;
    font-weight: 400;
    color: #6e6e6e;
    padding: 0;
  }
  &__paragraph2 {
    font-size: 14px;
    font-weight: 600;
    color: #1d3354;
    padding: 0;
  }
  &__border {
    border: 1px solid #dadee2;
    border-radius: 8px;
    @media only screen and (min-width: 1536px) {
      padding: 1.5rem;
    }
    padding: 1rem;
    column-gap: 1rem;
  }
  &__buttonwhite {
    width: 185px;
    height: 36px;
    color: #1d3354;
    border: 1px solid #1d3354;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
  &__buttonred {
    width: 100px;
    height: 36px;
    color: #c4232a;
    border: 1px solid #c4232a;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    background: #ffffff;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.011em;
  }
}
#checkboxAir {
  font-size: 14px !important;
  color: #686868 !important;
}
.titleTable {
  background: #1d3354;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
.paragraphTable {
  color: #1d3354;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.alert {
  font-size: 14px;
  font-weight: 600;
}
.menutabs {
  color: var(--neutral-50, #bec2c5);
  text-align: center;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  border: none;
  padding: 0px 15px;
  height: 44px;
  font-size: 14px;
  background-color: transparent;
  outline: none !important;
}
.menuactive {
  color: #1d3354;
  font-weight: 700;
  border-bottom: 2px solid #1d3354;
}
.customplaceholder {
  ::placeholder {
    color: #9ea1a4 !important;
  }

  @media only screen and (min-width: 1536px) {
    width: 100%;
  }

  width: 73%;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouse/inboundList/detail.vue